<div class="buttons">
  <div class="button" (click)="addTicket()">Ticket erstellen</div>
</div>
